import { useEffect, useState } from "react";
import useProfile from "../../hooks/useProfile";
import Modal from "../Modal";
import ExpiryContent from "./ExpiryContent";
import { login } from "../../utils/msalAuth";

const SessionExpiry = () => {
  const { tokenData } = useProfile();
  const exp = tokenData?.exp;
  const [showPopUp, setShowPopUp] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const storeParams = () => {
    const search = globalThis.location.search;
    if (search) {
      const urlParams = new URLSearchParams(search);
      localStorage.setItem("urlParams", urlParams);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const expiryTime = new Date(exp * 1000);
      const currentTime = new Date();
      const secondsDifference = Math.floor((expiryTime - currentTime) / 1000);
      const minutesDifference = Math.floor(secondsDifference / 60);
      setTimeLeft(secondsDifference);
      if (secondsDifference <= 0) {
        setShowPopUp(false);
        clearInterval(interval);
        localStorage.setItem("sessionExpired", true);
        storeParams();
        localStorage.removeItem("accessToken");
        window.location.href = "/ui/";
      } else if (minutesDifference < 10) {
        if (!JSON.parse(localStorage.getItem("sessionShowed"))) {
          setShowPopUp(true);
          localStorage.setItem("sessionShowed", JSON.stringify(true));
        }
      } else {
        localStorage.removeItem("sessionShowed");
        setShowPopUp(false);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [exp]);
  const logout = () => {
    localStorage.clear();
    window.location.href = "/ui/";
  };
  const relogin = () => {
    storeParams();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("sessionShowed");
    login();
  };

  if (showPopUp)
    return (
      <Modal
        title="Inactivity Alert"
        canelText="Log Out Now"
        okText="Continue Session"
        open={showPopUp}
        setOpen={setShowPopUp}
        onSubmit={relogin}
        onCancel={logout}
      >
        <ExpiryContent timeLeft={timeLeft} />
      </Modal>
    );
  else return;
};

export default SessionExpiry;
